import { render, staticRenderFns } from "./ContentManagement.vue?vue&type=template&id=3b55893b&scoped=true&"
import script from "./ContentManagement.vue?vue&type=script&lang=js&"
export * from "./ContentManagement.vue?vue&type=script&lang=js&"
import style0 from "./ContentManagement.vue?vue&type=style&index=0&id=3b55893b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55893b",
  null
  
)

export default component.exports